'use client'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { ArrowRight, Check, Wifi, Signal, BatteryFull, Home, ArrowLeftRight, History, User } from 'lucide-react'

export default function Hero() {
    const t = useTranslations('Hero')

    return (
        <section
            style={{backgroundImage: "url('/images/homepage/hero.png')"}}
            className="relative bg-cover bg-center w-full bg-white overflow-hidden"
        >
            <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center px-6 sm:px-10 lg:px-16 py-14 lg:py-24">
                <div className="lg:col-span-6 flex flex-col space-y-7">
                    <span
                        className="hero-fade-up inline-flex items-center w-fit text-[11px] sm:text-xs font-semibold tracking-wide text-gray-500 uppercase bg-gray-100 rounded-lg px-4 py-1.5"
                        style={{ animationDelay: '0ms' }}
                    >
                        {t('badge_text')}
                    </span>
                    <h1
                        className="hero-fade-up text-4xl sm:text-5xl lg:text-6xl font-bold text-black tracking-tight leading-[1.1]"
                        style={{ animationDelay: '120ms' }}
                    >
                        {t('title_line1')} {t('title_line2')}{' '}
                    </h1>
                    <p
                        className="hero-fade-up text-base sm:text-lg text-dark leading-relaxed font-normal max-w-xl"
                        style={{ animationDelay: '240ms' }}
                    >
                        {t('description')}
                    </p>
                    <div className="hero-fade-up flex flex-wrap items-center gap-4 pt-2" style={{ animationDelay: '360ms' }}>
                        <Link
                            href="https://www.kuik.al/"
                            target='_blank'
                            className="btn-blink-hover inline-flex items-center justify-center gap-2 bg-badge hover:bg-red-700 text-white text-sm font-bold px-7 py-3.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg active:scale-95"
                        >
                            <span>{t('cta_explore')}</span>
                            <ArrowRight size={16} />
                        </Link>
                        <Link
                            href="/"onClick={(e) => {
                                e.preventDefault();
                                window.scrollTo({
                                top: document.documentElement.scrollHeight,
                                behavior: 'smooth',
                                });
                            }}
                            className="inline-flex items-center justify-center gap-2 bg-white border border-gray-200 hover:border-gray-300 text-black text-sm font-bold px-7 py-3.5 rounded-lg transition-all duration-200 active:scale-95"
                        >
                            <span>{t('cta_partner')}</span>
                            <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}